import axiosInstance from '@/shared/api/axios';
import type {
  ApiReturnRequest,
  ApiReturnsListParams,
  ApiReturnsListResponse,
  ApiReturnsPendingCountResponse,
} from '@/shared/types/api/returns';

export const apiReturnsList = async (
  params: ApiReturnsListParams,
): Promise<ApiReturnsListResponse> => {
  const { data } = await axiosInstance.get<ApiReturnsListResponse>('/returns', { params });
  return data;
};

export const apiReturnConfirm = async (id: number): Promise<ApiReturnRequest> => {
  const { data } = await axiosInstance.post<ApiReturnRequest>(`/returns/${id}/confirm`);
  return data;
};

export const apiReturnReject = async (
  id: number,
  reject_reason?: string,
): Promise<ApiReturnRequest> => {
  const { data } = await axiosInstance.post<ApiReturnRequest>(`/returns/${id}/reject`, {
    reject_reason,
  });
  return data;
};

export const apiReturnCancel = async (id: number): Promise<ApiReturnRequest> => {
  const { data } = await axiosInstance.post<ApiReturnRequest>(`/returns/${id}/cancel`);
  return data;
};

export const apiReturnsPendingCount = async (): Promise<number> => {
  const { data } = await axiosInstance.get<ApiReturnsPendingCountResponse>('/returns/pending-count');
  return data.count;
};
